import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface IBadge {
  type: "success" | "info" | "warning" | "danger";
  title: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomBadge',
  props: {
    type: { default: "info" },
    title: { default: "" }
  },
  setup(__props: any) {


const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-cu-badge", __props.type])
  }, _toDisplayString(__props.title), 3))
}
}

})